import { getReportData } from '@/api/methods/reports/reports';

export function getMailStat(tree, dateFrom, dateTo) {
  const link = `/reports/internet/mail?dateFrom=${dateFrom}&dateTo=${dateTo}`;
  const object = { computersTree: tree };

  return getReportData(link, object);
}

export function getMessengersStat(tree, dateFrom, dateTo) {
  const link = `/reports/internet/messengers?dateFrom=${dateFrom}&dateTo=${dateTo}`;
  const object = { computersTree: tree };

  return getReportData(link, object);
}

export function getGroupedMessengerStat(tree, dateFrom, dateTo) {
  const link = `/reports/internet/details-messengers?dateFrom=${dateFrom}&dateTo=${dateTo}`;
  const object = { computersTree: tree };

  return getReportData(link, object);
}

export function getTrafficByGroups(compIds, tree, dateFrom, dateTo, trafficKind) {
  const link = `/reports/internet/traffic-by-groups?dateFrom=${dateFrom}&dateTo=${dateTo}&trafficKind=${trafficKind}`;

  return getReportData(link, { compIds, computersTree: tree });
}

export function getTrafficDetailed(compId, dateFrom, dateTo, trafficKind) {
  const params = new URLSearchParams({
    compId,
    dateFrom,
    dateTo,
    trafficKind,
  });

  const link = `/reports/internet/traffic-detailed?${params.toString()}`;

  return getReportData(link);
}
